import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAppDispatch, useAppSelector } from "@/stores/hook";
import { setIsFollowUpOverrideConfirmation } from "@/features/leads/stores/leadFunctionalSlice";
import { Textarea } from "@/components/ui/textarea";
import { useLeadForm } from "@/features/leads/contexts/FormLeadContext";
import { useActiveDataMutation } from "@/features/leads/hook/useActiveDataMutation";

export default function FollowUpOverrideConfirmation() {
  const { isFollowUpOverrideConfirmation } = useAppSelector(
    (state) => state.leadFunctional
  );

  const dispatch = useAppDispatch();
  const { addFollowUp } = useActiveDataMutation();
  const { watch } = useLeadForm();
  const followUpDate = watch("followUpDate");

  const [followupNote, setFollowupNote] = useState("");

  const {
    currentUser: { user },
  } = useAppSelector((state) => state.auth);

  const handleCreateNewFollowup = () => {
    // ✅ Create followup object (without changing your zod types)
    const followUpObj = {
      date: followUpDate,
      note: {
        note: followupNote,
        createdById: user.id,
        createdByName: user.name,
        createdAt: new Date().toISOString(),
      },
      createdBy: {
        id: user.id,
        name: user.name,
      },
      createdAt: new Date().toISOString(),
      status: "Pending",
      completedBy: {}, // keep it empty until completed
    };

    addFollowUp(followUpObj);

    setFollowupNote("");
    dispatch(setIsFollowUpOverrideConfirmation(false));
  };

  return (
    <Dialog
      open={isFollowUpOverrideConfirmation}
      onOpenChange={() =>
        dispatch(
          setIsFollowUpOverrideConfirmation(!isFollowUpOverrideConfirmation)
        )
      }
    >
      <DialogContent className="sm:max-w-[500px] rounded-[24px] p-0 gap-0">
        <DialogHeader className="px-4 pt-[11px] pb-[11px] border-b border-[#e6e8e7]">
          <div className="flex items-start justify-between gap-2">
            <p className="text-[18px] font-medium text-black tracking-[-0.72px] leading-normal flex-1">
              Create New Follow-Up?
            </p>
          </div>
        </DialogHeader>

        <div className="px-4 py-4">
          <DialogDescription className="text-[#697571] text-[14px] tracking-[-0.56px] leading-[1.35]">
            A follow-up is already active for this lead.
            <br />
            Creating a new one will mark the current follow-up as complete.
            <br />
            <div className="my-4 font-medium">
              Are you sure you want to continue?
            </div>
            {/* ✅ Notes input for the new follow up */}
            <Textarea
              value={followupNote}
              onChange={(e) => setFollowupNote(e.target.value)}
              placeholder="Type your follow-up note..."
              className="min-h-[90px] border-[#cdd1d0] rounded-[12px] text-[14px] text-[#1e302a] tracking-[-0.32px] resize-none focus-visible:ring-1 focus-visible:ring-[#1e302a]"
            />
          </DialogDescription>
        </div>

        <DialogFooter className="px-4 pb-4 pt-2 border-t border-[#e6e8e7] flex justify-end gap-2">
          <DialogClose asChild>
            <Button variant="cancel" className="w-[120px]">
              Cancel
            </Button>
          </DialogClose>

          <Button variant="primary" onClick={handleCreateNewFollowup}>
            Create new followup
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
